/**
 * Maps the real-world clock hour onto a shift's list of hour slots
 * (e.g. ["7-8", "8-9", ...] for day, wrapping past midnight for night).
 *
 * Returns the index of the in-progress ("live") slot, or -1 when there is none:
 * either the displayed shift is not the latest shift, or the current time falls
 * outside the shift window. The slot whose start hour equals the current clock
 * hour is considered live.
 */
export function resolveLiveHourIndex(
  hours: string[],
  currentClockHour: number | null,
  isLatestShift: boolean
): number {
  if (!isLatestShift || currentClockHour == null) return -1;

  return hours.findIndex(slot => parseInt(slot.split("-")[0], 10) === currentClockHour);
}

/** True when the hour slot at `index` is later than the live slot and therefore not yet reached. */
export function isHourSlotInFuture(index: number, liveHourIndex: number): boolean {
  return liveHourIndex >= 0 && index > liveHourIndex;
}
